import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCAlertBox } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { IUserContext, withUserContext } from '@reverbdotcom/commons';
import experiments from '@reverbdotcom/commons/src/experiments';
import { signinUrl } from '@reverbdotcom/commons/src/signup_signin_helper';

function GiftCardsUnderConstruction({ user }: IUserContext) {
  const displayUserLoginPrompt = () => {
    return isExperimentEnabled(user, experiments.DISPLAY_USERS_LOGIN_REQUIRED_FOR_GIFT_CARDS);
  };

  return (
    <div className="mt-4 mb-4">
      { !displayUserLoginPrompt() &&
        <>
          <RCAlertBox
            type="warning"
            headerText={<Translate text="discovery.giftCardsUnderConstruction.unavailableTitle" />}
          >
            <Translate
              tag="p"
              text="discovery.giftCardsUnderConstruction.unavailableMessageHtml"
            >
              <CoreLink to="https://reverb.com/news/last-minute-gifts-musicians-will-actually-love">
                <Translate text="discovery.giftCardsUnderConstruction.giftIdeasLinkText" />
              </CoreLink>
            </Translate>
          </RCAlertBox>

          <div className="mt-4">
            <RCAlertBox
              type="info"
              headerText={<Translate text="discovery.giftCardsUnderConstruction.redeemTitle" />}
            >
              <Translate
                tag="p"
                text="discovery.giftCardsUnderConstruction.redeemHtml"
              >
                <CoreLink to="/redeem">
                  <Translate text="discovery.giftCardsUnderConstruction.redeemLinkText" />
                </CoreLink>
              </Translate>
            </RCAlertBox>
          </div>
        </>
      }
      { displayUserLoginPrompt() &&
        <>
          <div className="mt-4">
            <RCAlertBox
              type="info"
              headerText={<Translate text="discovery.giftCardsUnderConstruction.loginPromptTitle" />}
            >
              <Translate
                tag="p"
                text="discovery.giftCardsUnderConstruction.loginPromptHtml"
              >
                <CoreLink to={signinUrl('GiftCards', window.location.href)}>
                  <Translate text="discovery.giftCardsUnderConstruction.loginLinkText" />
                </CoreLink>
              </Translate>
            </RCAlertBox>
          </div>
        </>
      }
    </div>
  );
}

export default withUserContext(GiftCardsUnderConstruction);
